import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Meteor = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M19 24C16.238 24 14 21.762 14 19C14 16.238 16.238 14 19 14C21.762 14 24 16.238 24 19C24 21.762 21.762 24 19 24ZM19 16C17.35 16 16 17.35 16 19C16 20.65 17.35 22 19 22C20.65 22 22 20.65 22 19C22 17.35 20.65 16 19 16Z" />
		<path d="M26.788 11.287L17.701 2.28699C17.526 2.11199 17.276 1.99899 17.001 1.99899C16.451 1.99899 16.001 2.44899 16.001 2.99899V9.27399L3.50101 2.13599C3.35101 2.04899 3.18801 1.99799 3.00101 1.99799C2.45101 1.99799 2.00101 2.44799 2.00101 2.99799C2.00101 3.17299 2.05101 3.34799 2.13901 3.49799L9.28901 15.998H3.00201C2.45201 15.998 2.00201 16.448 2.00201 16.998C2.00201 17.273 2.11401 17.523 2.29001 17.698L11.29 26.786C13.327 28.824 16.153 29.998 19.04 29.998C21.953 29.998 24.69 28.848 26.778 26.773C28.853 24.698 30.003 21.948 30.003 19.035C30.003 16.16 28.828 13.335 26.791 11.285L26.788 11.287ZM25.363 25.363C23.663 27.063 21.413 28 19.038 28C16.675 28 14.376 27.038 12.7 25.375L5.38701 18H10.999C11.362 18 11.687 17.812 11.862 17.5C12.037 17.188 12.037 16.812 11.862 16.5L5.68701 5.68699L16.5 11.862C16.813 12.037 17.188 12.037 17.5 11.862C17.812 11.687 18 11.35 18 10.999V5.39899L25.375 12.712C27.038 14.374 28 16.687 28 19.05C28 21.413 27.062 23.663 25.363 25.363Z" />
	</svg>
);

export default Meteor;
